export default __webpack_public_path__ + "static/media/searching.1893224b.png";